export default {
  base: {
    fontWeight: 500,
    fontSize: '16px',
    fontFamily: 'Roboto, sans-serif',
    ':-webkit-autofill': {
      color: '#e39f48'
    }
  },
  invalid: {
    color: '#ff5252 ',

    '::placeholder': {
      color: '#ff5252 '
    }
  }
}
